module.exports = __webpack_public_path__ + "static/img/roboto-v32-cyrillic_cyrillic-ext_latin_latin-ext-900.9c4bede.svg";